// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"893":"0dcbc132","976":"708dc404"}[chunkId] + ".chunk.js");